// extracted by mini-css-extract-plugin
module.exports = {"title":"tKIatt2Ef4RyhYfoS8tli","error":"_8wCVbCol3C1ZYyxlOtvPS","notification":"_1BtMmFE0iShii3Z_5IKhiG","dialog":"_1hRWVRIDCNCKJuLEXi2bZ3"};